export default __webpack_public_path__ + "static/media/bg-new-pintar.930d9cea.webp";